import http from 'core/services/http';
import Config from 'core/config';
import isEqual from 'lodash/isEqual';
import Auth from 'core/services/authToken';

class RoomPollingService {
  constructor({ url, action, cb, intervalTime }) {
    this.pollUrl = url;
    this.action = action;
    this.intervalId = null;
    this.intervalTime = intervalTime || 15 * 1000;
    this.prevData = {};
    this.callback = cb;
    this.startInterval();
    // return this;
  }
  stop() {
    if (!this.intervalId) {
      return;
    }
    clearInterval(this.intervalId);
    this.intervalId = null;
  }
  set pollUrl(url) {
    this.url = url;
  }
  get pollUrl() {
    return this.url;
  }
  set intervalId(id) {
    this.iid = id;
  }
  get intervalId() {
    return this.iid;
  }
  set intervalTime(time) {
    this.iTime = time;
  }
  get intervalTime() {
    return this.iTime;
  }
  set prevData(data) {
    this.previousData = data;
  }
  get prevData() {
    return this.previousData;
  }
  set callback(cb) {
    if (cb && typeof cb === 'function') {
      this.cb = cb;
      return;
    }
    this.cb = () => {};
  }
  get callback() {
    return this.cb;
  }
  isStarted() {
    return !!this.intervalId;
  }
  startInterval() {
    this.intervalId = setInterval(this.onInterval.bind(this), this.intervalTime);
  }
  onInterval() {
    const self = this;
    // not authenticated, make sure we stop polling
    if (!Auth.authToken) {
      this.stop();
      return;
    }
    this.getStatus()
      .then((response) => {
        if (!isEqual(self.prevData, response)) {
          //  don't execute callback if nothing changed
          self.callback && self.callback(response);
        }
        self.prevData = response;
      });
  }
  getStatus() {
    if (this.action) {
      return this.action();
    }
    return http.get(`${Config.apiUrl}/${this.pollUrl}`);
  }
  hasChanged() {
    this.getStatus()
      .then((response) => {
        if (this.prevData !== response) {
          this.prevData = response;
          return true;
        }
        return false;
      });
  }
};

export default RoomPollingService;
